import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnchor, faTimes } from '@fortawesome/free-solid-svg-icons';
import '../styles/SubscriptionCTADialog.css';

/**
 * Full-page overlay shown to authenticated users who lack a subscription.
 * Renders blurred content beneath the overlay to hint at what's available.
 *
 * Props:
 *   feature      — short name, e.g. "Roommate Finder"
 *   description  — 1–2 sentence description of the feature
 *   benefits     — string[] of bullet-point benefits
 *   onDismiss    — optional callback to close/minimise (shows X button)
 */
function SubscriptionCTADialog({ feature, description, benefits = [], onDismiss }) {
  const navigate = useNavigate();

  return (
    <div className="sub-cta-overlay" role="dialog" aria-modal="true" aria-label={`Subscribe to access ${feature}`}>
      <div className="sub-cta-card">
        {onDismiss && (
          <button className="sub-cta-close" onClick={onDismiss} aria-label="Dismiss">
            <FontAwesomeIcon icon={faTimes} />
          </button>
        )}

        <div className="sub-cta-icon">
          <FontAwesomeIcon icon={faAnchor} />
        </div>

        <h2 className="sub-cta-title">
          Unlock <span>{feature}</span>
        </h2>

        {description && (
          <p className="sub-cta-description">{description}</p>
        )}

        {benefits.length > 0 && (
          <ul className="sub-cta-benefits">
            {benefits.map((b, i) => (
              <li key={i}>{b}</li>
            ))}
          </ul>
        )}

        <button
          type="button"
          className="sub-cta-primary"
          onClick={() => navigate('/account/subscriptions')}
        >
          View Membership Plans →
        </button>

        <p className="sub-cta-note">
          Already a member?{' '}
          <button
            type="button"
            className="sub-cta-link"
            onClick={() => navigate('/account/subscriptions')}
          >
            Manage your subscription
          </button>
        </p>
      </div>
    </div>
  );
}

export default SubscriptionCTADialog;
